/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import { cloneDeep, isUndefined } from 'lodash';
import { Fragment, useCallback, useState, useMemo, useEffect } from 'react';
import { FiX } from 'react-icons/fi';
import { useMutation, useQuery } from 'react-query';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useUnmount, useUpdateEffect } from 'react-use';

import { FieldLayout } from '../../components/Layouts/FieldLayout11';
import { FormFilterPlayers } from '../../components/Team/FormFilterPlayers';
import { DesktopSidebar, MobileSidebar } from '../../components/Team/Sidebar';
import { useBalance } from '../../hooks/useBalance';
import { lockScroll, showErrorToast } from '../../utils/functions';
import { resolverTeamBalance } from '../../utils/tacticUtils';

import { ChangeTacticLayout } from './components/ChangeTacticLayout';
import TeamFormationWrapper from './components/TeamFormationWrapper';

import {
  Button,
  FieldPlayer,
  Loader,
  Modal,
  SliderOver,
  NavBar,
} from '@/components';
import {
  DetailsPlayer,
  DetailsPlayerSubmit,
} from '@/components/Team/DetailsPlayer';
import useAuth from '@/hooks/useAuth';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import {
  useGetPlayerPositionByAbbreviation,
  usePlayerClub,
} from '@/hooks/usePlayer';
import { useTeamStore } from '@/hooks/useTeamStore';
import useToast from '@/hooks/useToast';
import ROUTES from '@/router/routes';
import { getInitBuildTeam, saveTeamDraft } from '@/services/buildTeam11';
import { TeamActionTypes } from '@/store/team';
import {
  EnumPosition,
  GDTApiErrors,
  KeysOf,
  Maybe,
  ChangeTacticAction,
  Optional,
} from '@/types';
import {
  PlayerClub,
  PlayerComponentInField,
  RequestEquipoBorrador,
  ResponseArmaEquipoGrabar,
  ResponseGetInitDraftTeam,
  TacticOnField,
  Step,
  TemplatePlayer,
  EnumTeamContext,
} from '@/types/team';
import {
  POSITIONS_LABELS,
  TACTICS_ARR,
  TEXTS,
  capitalize,
  getPlayersOnFieldCount,
  pluralizeWord,
  tacticToString,
  isSelectedPlayerFromList,
  resolvePlayerPrice,
  PLAYER_POSITION_BY_ID,
  getShortNamePlayerPosition,
  PLAYER_ENGLISH_LABEL_BY_ID,
  MAX_INPUT_RANGE,
  MIN_INPUT_RANGE,
  parseJSXElementToPlayerClub,
  getPlayerPositionListOnField,
  TEAM_LIST,
  countStringOccurrences,
} from '@/utils';
import { TacticDescriptor } from '@/utils/tacticUtils';

type PositionCount = {
  def: number;
  vol: number;
  del: number;
};

const translateNumberWord = {
  1: 'un',
  2: 'dos',
  3: 'tres',
  4: 'cuatro',
  5: 'cinco',
} as const;

export const ChangeTactic = () => {
  const [searchParams] = useSearchParams();
  const newTacticId = searchParams.get('id');
  const navigate = useNavigate();
  const toast = useToast();
  const { isDesktop, isMobile } = useIsDesktop();
  const { userInitialData } = useAuth();
  const { state, dispatch } = useTeamStore();
  const { setTeamBalanceByResult, setTeamBalance } = useBalance();
  const { resolvePlayerClubData } = usePlayerClub();
  const step = state.step;

  const [fieldIsReady, setFieldIsReady] = useState(false);
  const [instruction, setInstruction] = useState<Maybe<string>>(null);
  const [withAddAction, setWithAddAction] = useState(false);

  useEffect(() => {
    lockScroll(isDesktop);

    return () => {
      lockScroll();
    };
  }, [isDesktop]);

  const playersOnFieldCount: number = useMemo(() => {
    const count = getPlayersOnFieldCount(state.playersOnField);
    if (count === 10) {
      setWithAddAction(true);
    }
    return count;
  }, [state.playersOnField]);

  const handleGoBack = () => {
    dispatch({
      type: TeamActionTypes.RESET,
    });
    navigate(ROUTES.buildTeam11, {
      replace: true,
    });
  };

  const { isLoading } = useQuery(
    'getBuildTeam',
    async () => await getInitBuildTeam(),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(newTacticId),
      keepPreviousData: false,
      onSuccess: (response) => {
        if (response) {
          if (response.estado) {
            setBalanceAndTeam(response, true);
          } else {
            showErrorToast(response);
            if (response.codError === 403) return;
            // EQUIPO_YA_REGISTRADO (214)
            // Hago un redirecto a summary si el usuario ya tiene equipo registrado
            // Pero por alguna razon lograr entrar en esta pagina.
            if (response.codError === 214) {
              navigate(ROUTES.summary, {
                replace: true,
              });
            }
          }
        } else {
          toast.show(TEXTS.getTeam, true);
        }
      },
    }
  );

  const { mutateAsync: submitNewTeam, isLoading: isLoadingOnSubmit } =
    useMutation(
      async (newTeamDraft: RequestEquipoBorrador) =>
        await saveTeamDraft(newTeamDraft),
      {
        onSuccess: (newSavedTeam) => {
          if (newSavedTeam.estado === false) {
            toast.show(newSavedTeam.mensaje, true);
            return;
          }

          if (newSavedTeam.estado && newSavedTeam.equipoBorrador) {
            dispatch({
              type: TeamActionTypes.SET_STATE,
              payload: {
                teamDraft: newSavedTeam.equipoBorrador?.jugadores,
                tactic: {
                  id: newSavedTeam.equipoBorrador.idTactica,
                  formation: TACTICS_ARR[newSavedTeam.equipoBorrador.idTactica],
                },
              },
            });
            navigate(ROUTES.buildTeam11, { replace: true });
          }
        },
        onError: (error: GDTApiErrors) => {
          console.log(error);
          toast.show(error.mensaje, true);
        },
      }
    );

  const setBalanceAndTeam = (
    newTeamDraft: ResponseGetInitDraftTeam | ResponseArmaEquipoGrabar,
    isGetDataInit: boolean
  ) => {
    const result = resolverTeamBalance(
      newTeamDraft,
      isGetDataInit,
      state.tournamentPrice
    );

    if (newTeamDraft.equipoBorrador && result) {
      setTeamBalanceByResult(result);

      if (newTacticId) {
        return handleInit(
          Number(newTacticId),
          newTeamDraft.equipoBorrador.idTactica,
          newTeamDraft.equipoBorrador.jugadores
        );
      }
    }

    toast.show(TEXTS.defaultError);
  };

  /*
   * toma dos números como entrada y devuelve la cantidad de elementos enteros no negativos
   * entre esos dos números
   * Esta funcion es importante para poder saber si hay diferencias entre un array o no.
   */
  const countElementsBetween = (num1: number, num2: number) => {
    // Verificar que num1 sea menor o igual a num2
    if (num1 > num2) {
      [num1, num2] = [num2, num1];
    }

    // Calcular la cantidad de elementos entre num1 y num2
    const cantidadElementos = Math.max(0, num2 - num1);

    return cantidadElementos;
  };

  /*
   * Esta funcion se encarga de contar cuantos jugadores hay que ELIMINAR por posicion.
   * Para luego construir los mensajes de la UI en el montado del componente
   */
  const getInitialPlayersAddDeleteCount = () => {
    const parseNewTacticId = newTacticId as unknown as Maybe<number>;

    const options = {
      delete: {
        def: 0,
        vol: 0,
        del: 0,
        total: 0,
      },
      add: {
        def: 0,
        vol: 0,
        del: 0,
        total: 0,
      },
      total: 0,
    };

    if (parseNewTacticId && state.playersOnField) {
      const newTacticArray: number[] = TACTICS_ARR[parseNewTacticId];

      // Diferencias para el borrado
      const descriptor = new TacticDescriptor(newTacticArray);

      // Defensas
      const newTacticDefCount = descriptor.calcLineSize(EnumPosition.DEF);
      const currentTacticDefCount = state.playersOnField.defenders.filter(
        (player: PlayerComponentInField) => {
          return player.props?.data?.id;
        }
      ).length;

      const defDiff = currentTacticDefCount - newTacticDefCount;

      if (defDiff >= 0) {
        options.delete.def += defDiff;
      } else {
        options.add.def += Math.abs(defDiff);
      }

      // Volantes
      const newTacticVolCount = descriptor.calcLineSize(EnumPosition.MID);
      const currentTacticVolCount = state.playersOnField.midfielders.filter(
        (player: PlayerComponentInField) => {
          return player.props?.data?.id;
        }
      ).length;

      const volDiff = currentTacticVolCount - newTacticVolCount;

      if (volDiff >= 0) {
        options.delete.vol += volDiff;
      } else {
        options.add.vol += Math.abs(volDiff);
      }

      // Delanteros
      const newTacticDelCount = descriptor.calcLineSize(EnumPosition.FWD);
      const currentTacticDelCount = state.playersOnField.forwards.filter(
        (player: PlayerComponentInField) => {
          return player.props?.data?.id;
        }
      ).length;

      const delDiff = currentTacticDelCount - newTacticDelCount;

      if (delDiff >= 0) {
        options.delete.del += delDiff;
      } else {
        options.add.del += Math.abs(delDiff);
      }

      // Total sum
      const deleteCountArr = [
        options.delete.def,
        options.delete.vol,
        options.delete.del,
      ];

      const addCountArr = [options.add.def, options.add.vol, options.add.del];

      const deleteCount = deleteCountArr.reduce((a, b) => a + b, 0);
      const addCount = addCountArr.reduce((a, b) => a + b, 0);

      options.delete.total = deleteCount;
      options.add.total = addCount;
      options.total = deleteCount + addCount;
    }

    return options;
  };

  /*
   * Esta funcion se encarga de retornar un string en conjunto con la posicion
   * {Example}: Eliminar dos delanteros, Agregar 4 volantes... etc.
   */
  const getAddOrDeletePositionLabel = (
    positionCount: number,
    positionLabel: KeysOf<typeof POSITIONS_LABELS.spanish_singular>,
    action: ChangeTacticAction
  ) => {
    const POSITION_WORD = POSITIONS_LABELS.spanish_singular[positionLabel];

    const parseAction =
      action === ChangeTacticAction.ADD ? 'agregá' : 'eliminá';

    const key = positionCount as KeysOf<typeof translateNumberWord>;

    const position =
      positionCount > 1 ? pluralizeWord(POSITION_WORD) : POSITION_WORD;
    return `${parseAction} ${translateNumberWord[key]} ${capitalize(position)}`;
  };

  /*
   * Esta funcion se encarga de retornar un string con el armado de las instrucciones y su parseo
   */
  const getInitialInstructionLabel = (
    deleteCount: PositionCount,
    addCount: PositionCount
  ) => {
    let baseText = ',';

    if (deleteCount.def > 0) {
      const message = getAddOrDeletePositionLabel(
        deleteCount.def,
        'defensor',
        ChangeTacticAction.DELETE
      );
      baseText += `, ${message}`;
    }

    if (deleteCount.vol > 0) {
      const message = getAddOrDeletePositionLabel(
        deleteCount.vol,
        'volante',
        ChangeTacticAction.DELETE
      );
      baseText += `, ${message}`;
    }

    if (deleteCount.del > 0) {
      const message = getAddOrDeletePositionLabel(
        deleteCount.del,
        'delantero',
        ChangeTacticAction.DELETE
      );
      baseText += `, ${message}`;
    }

    // TO ADD
    if (addCount.def > 0) {
      const message = getAddOrDeletePositionLabel(
        addCount.def,
        'defensor',
        ChangeTacticAction.ADD
      );
      baseText += `, ${message}`;
    }

    if (addCount.vol > 0) {
      const message = getAddOrDeletePositionLabel(
        addCount.vol,
        'volante',
        ChangeTacticAction.ADD
      );
      baseText += `, ${message}`;
    }

    if (addCount.del > 0) {
      const message = getAddOrDeletePositionLabel(
        addCount.del,
        'delantero',
        ChangeTacticAction.ADD
      );
      baseText += `, ${message}`;
    }

    // split basetext where "-" and add the letter y before the last-1 element
    const baseTextArr = baseText.split(',');
    return baseTextArr.slice(1, -1).join(', ') + ' y' + baseTextArr.slice(-1);
  };

  /*
   * Esta funcion se encarga de eliminar al jugador seleccionado del playersOnField.
   */
  const deletePlayerFromField = (
    player: TemplatePlayer,
    toBeSubstitute?: boolean
  ) => {
    const { id, p } = player;

    const fieldKey = {
      2: 'defenders',
      3: 'midfielders',
      4: 'forwards',
    } as const;

    const field = fieldKey[p as KeysOf<typeof fieldKey>];

    if (state.playersOnField) {
      const newState = {
        ...state.playersOnField,
        [field]: state.playersOnField[field].filter(
          (player: PlayerComponentInField) => {
            return player.props?.data?.id !== id;
          }
        ),
        ...(toBeSubstitute && { substitutes: setSubstitutes(player) }),
      } as TacticOnField;

      dispatch({
        type: TeamActionTypes.SET_STATE,
        payload: {
          playersOnField: newState,
          selectedPlayerOnBuildTeam: null,
          playerDetailsModalOpen: false,
        },
      });
      return true;
    } else {
      toast.show(TEXTS.defaultError);
      return false;
    }
  };

  // Esta funcion se encarga de poner jugador de suplente
  const setSubstitutes = (newPlayer: TemplatePlayer) => {
    const incommingSubstitute = resolvePlayerClubData(newPlayer);

    // Fix para mapear los IDs de las posiciones con las posiciones de los subtitutos.
    const substituteMap = new Map([
      [2, 12],
      [3, 13],
      [4, 14],
    ]);

    if (incommingSubstitute && state.playersOnField) {
      return state.playersOnField.substitutes.map(
        (player: PlayerComponentInField) => {
          const dataSubstitutes = player.props?.data;

          if (incommingSubstitute.posicion?.id) {
            const subtitutesPositionOrden = substituteMap.get(
              incommingSubstitute.posicion?.id
            );

            if (subtitutesPositionOrden) {
              const selectedSubstitute =
                dataSubstitutes?.orden === subtitutesPositionOrden;

              if (selectedSubstitute) {
                return (
                  <FieldPlayer
                    key={incommingSubstitute.orden + 10}
                    data={{
                      ...incommingSubstitute,
                      cotizacion: resolvePlayerPrice(
                        incommingSubstitute.cotizacion
                      ),
                      orden: incommingSubstitute.orden + 10,
                    }}
                    id={String(incommingSubstitute?.id)}
                    positionLabel={String(
                      getShortNamePlayerPosition(newPlayer.p)
                    )}
                    onClick={() => {
                      handleSelectPlayer({
                        ...incommingSubstitute,
                        posicion: {
                          nombreCorto: getShortNamePlayerPosition(newPlayer.p),
                          id: newPlayer.p,
                        },
                      });
                    }}
                  />
                );
              }
            }
          }

          return player;
        }
      );
    }

    return null;
  };

  const setNewPlayerOnField = (player: TemplatePlayer) => {
    const parsedPlayerData = resolvePlayerClubData(player);

    /**
     * Description
     * Validacion para que no se pueda agregar mas de 4 jugadores del mismo equipo
     */
    const club = TEAM_LIST.find((item) => {
      return item.value === player.c;
    });

    if (club) {
      const clubLabel = club.label;

      const parsedCollection = parseJSXElementToPlayerClub(
        getPlayerPositionListOnField(state.playersOnField)
      )
        .map((player) => player.club)
        .filter((item) => typeof item === 'string') as string[];

      const count = countStringOccurrences(clubLabel, parsedCollection);

      if (count === 4) {
        return {
          success: false,
          message: TEXTS.sameTeamLimit,
        };
      }
    }

    /**
     * Description
     * Validacion para cuando te quedas sin presupuesto
     */
    const playerPrice = resolvePlayerPrice(player.cot);

    if (state.balance) {
      const nextTotalBalance = state.balance - playerPrice;

      if (nextTotalBalance < 0) {
        return {
          success: false,
          message: TEXTS.noBudget,
        };
      }
    } else {
      return {
        success: false,
      };
    }

    /**
     * Description
     * Function que te retorna la configuracion de la posicion a llenar.
     */
    const getPositionToFillConfig = () => {
      if (state.playersOnField) {
        const playerPosition = player.p as KeysOf<
          typeof PLAYER_ENGLISH_LABEL_BY_ID
        >;
        const positionLabel = PLAYER_ENGLISH_LABEL_BY_ID[playerPosition];
        const positionsArr = state.playersOnField[positionLabel];

        if (state.selectedPlayerOnBuildTeam) {
          return {
            orden:
              'orden' in state.selectedPlayerOnBuildTeam &&
              state.selectedPlayerOnBuildTeam.orden,
            positionsArr: positionsArr as JSX.Element[],
            positionLabel,
          };
        }

        if (Array.isArray(positionsArr)) {
          const position = parseJSXElementToPlayerClub(positionsArr).find(
            (item) => !item.id
          );

          if (position) {
            return {
              orden: position.orden,
              positionsArr,
              positionLabel,
            };
          }

          return null;
        }

        return null;
      }

      return null;
    };

    const positionToFill = getPositionToFillConfig();

    if (positionToFill) {
      const { orden, positionsArr, positionLabel } = positionToFill;

      const indexToBeReplaced = positionsArr.findIndex(
        (item: PlayerComponentInField) => {
          return item.props?.data?.orden === orden;
        }
      );

      const newItem = orden ? (
        <FieldPlayer
          key={orden}
          data={{
            ...parsedPlayerData,
            cotizacion: resolvePlayerPrice(parsedPlayerData.cotizacion),
            orden,
            titular: true,
          }}
          id={String(orden)}
          positionLabel={getShortNamePlayerPosition(player.p)}
          onClick={() => {
            handleSelectPlayer({
              ...parsedPlayerData,
              orden,
            });
          }}
        />
      ) : (
        <></>
      );
      const positionsArrCopy = cloneDeep(positionsArr);
      positionsArrCopy.splice(indexToBeReplaced, 1, newItem);

      const newState = {
        ...state.playersOnField,
        [positionLabel]: [...positionsArrCopy],
      } as TacticOnField;

      dispatch({
        type: TeamActionTypes.SET_STATE,
        payload: {
          playersOnField: newState,
        },
      });

      return {
        positionLabel,
        newState,
        success: true,
      };
    } else {
      toast.show(TEXTS.defaultError);
      return {
        success: false,
      };
    }
  };

  const handleClickPlayerAction = (submitData: DetailsPlayerSubmit) => {
    const { willBeDeleted, player, toBeSubtitute } = submitData;

    if (playersOnFieldCount === 0) {
      toast.show(TEXTS.defaultError);
      return;
    }

    // condicion para eliminar jugador en cancha
    if (willBeDeleted || toBeSubtitute) {
      const deleted = deletePlayerFromField(player, Boolean(toBeSubtitute));

      if (deleted && !isUndefined(state.balance) && state.balance >= 0) {
        if (toBeSubtitute) {
          const substitutePlayer: Optional<PlayerComponentInField> =
            state.playersOnField?.substitutes.find(
              (p: PlayerComponentInField) => {
                return p.props?.data?.posicion?.id === player.p;
              }
            );

          if (substitutePlayer && substitutePlayer.props?.data?.cotizacion) {
            const newBalance =
              state.balance + substitutePlayer.props.data.cotizacion;
            setTeamBalance(newBalance);
          }
        } else {
          const newBalance = state.balance + resolvePlayerPrice(player.cot);
          setTeamBalance(newBalance);
        }
      } else {
        toast.show(TEXTS.defaultError);
      }
    } else {
      const playerAdded = setNewPlayerOnField(player);

      if (
        playerAdded?.success &&
        !isUndefined(state.balance) &&
        state.balance >= 0 &&
        playerAdded.positionLabel &&
        state.playersOnField
      ) {
        const newBalance = state.balance - resolvePlayerPrice(player.cot);
        setTeamBalance(newBalance);

        if (isMobile) {
          const positionRow = playerAdded.newState[
            playerAdded.positionLabel
          ] as JSX.Element[];

          const nextPosition = parseJSXElementToPlayerClub(positionRow).find(
            (item) => !item.id
          );

          const payload = nextPosition
            ? {
                selectedPlayerOnBuildTeam: nextPosition,
                selectedPlayerOnList: null,
                playerDetailsModalOpen: false,
              }
            : {
                selectedPlayerOnBuildTeam: null,
                playerDetailsModalOpen: false,
              };

          dispatch({
            type: TeamActionTypes.SET_STATE,
            payload,
          });
        } else {
          dispatch({
            type: TeamActionTypes.SET_STATE,
            payload: {
              selectedPlayerOnBuildTeam: null,
              playerDetailsModalOpen: false,
            },
          });
        }
      } else {
        toast.show(playerAdded?.message ?? TEXTS.defaultError);
        dispatch({
          type: TeamActionTypes.SET_STATE,
          payload: {
            playerDetailsModalOpen: false,
          },
        });
      }
    }
  };

  /*
   * IMPORTANTE
   * Funcion para resetear los valores del reducer
   * Ya que el reducer es utilizado tambien en el BuildTeam11
   */
  const handleUnmount = useCallback(() => {
    dispatch({
      type: TeamActionTypes.SET_STATE,
      payload: {
        selectedPlayerOnBuildTeam: null,
        playerDetailsModalOpen: false,
        playersOnField: {
          goalkeepers: null,
          defenders: [],
          midfielders: [],
          forwards: [],
          substitutes: [],
        },
        step: null,
        selectedPosition: null,
        selectedPlayerOnList: null,
      },
    });
  }, [dispatch]);

  const handleClosePlayerDetailsModal = () => {
    const isUsedPosition = Boolean(state.selectedPlayerOnBuildTeam?.id);

    dispatch({
      type: TeamActionTypes.SET_STATE,
      payload: {
        ...(isUsedPosition && {
          selectedPlayerOnBuildTeam: null,
        }),
        playerDetailsModalOpen: false,
        selectedPlayerOnList: null,
      },
    });
  };

  const getNextStep = (): Maybe<Step> => {
    const { delete: playersToDeleteCount, add: playersToBeAddedCount } =
      getInitialPlayersAddDeleteCount();

    if (
      playersToDeleteCount.def > 0 ||
      playersToDeleteCount.vol > 0 ||
      playersToDeleteCount.del > 0
    ) {
      if (playersToDeleteCount.def > 0) {
        const message = getAddOrDeletePositionLabel(
          playersToDeleteCount.def,
          'defensor',
          ChangeTacticAction.DELETE
        );

        return {
          action: ChangeTacticAction.DELETE,
          position: EnumPosition.DEF,
          message,
        };
      } else if (playersToDeleteCount.vol > 0) {
        const message = getAddOrDeletePositionLabel(
          playersToDeleteCount.vol,
          'volante',
          ChangeTacticAction.DELETE
        );

        return {
          action: ChangeTacticAction.DELETE,
          position: EnumPosition.MID,
          message,
        };
      } else if (playersToDeleteCount.del > 0) {
        const message = getAddOrDeletePositionLabel(
          playersToDeleteCount.del,
          'delantero',
          ChangeTacticAction.DELETE
        );

        return {
          action: ChangeTacticAction.DELETE,
          position: EnumPosition.FWD,
          message,
        };
      }

      return null;
    }

    if (
      playersToBeAddedCount.def > 0 ||
      playersToBeAddedCount.vol > 0 ||
      playersToBeAddedCount.del > 0
    ) {
      if (playersToBeAddedCount.def > 0) {
        const message = getAddOrDeletePositionLabel(
          playersToBeAddedCount.def,
          'defensor',
          ChangeTacticAction.ADD
        );

        return {
          action: ChangeTacticAction.ADD,
          position: EnumPosition.DEF,
          message,
        };
      } else if (playersToBeAddedCount.vol > 0) {
        const message = getAddOrDeletePositionLabel(
          playersToBeAddedCount.vol,
          'volante',
          ChangeTacticAction.ADD
        );

        return {
          action: ChangeTacticAction.ADD,
          position: EnumPosition.MID,
          message,
        };
      } else if (playersToBeAddedCount.del > 0) {
        const message = getAddOrDeletePositionLabel(
          playersToBeAddedCount.del,
          'delantero',
          ChangeTacticAction.ADD
        );

        return {
          action: ChangeTacticAction.ADD,
          position: EnumPosition.FWD,
          message,
        };
      }
    }

    return null;
  };

  const setNextStep = (step: Step) => {
    dispatch({
      type: TeamActionTypes.SET_STATE,
      payload: {
        step,
        ...(step.action === ChangeTacticAction.ADD && {
          selectedPosition:
            PLAYER_POSITION_BY_ID[
              step.position as KeysOf<typeof PLAYER_POSITION_BY_ID>
            ],
        }),
      },
    });
  };

  const handleSaveNewTeam = async () => {
    if (state.playersOnField && newTacticId && userInitialData) {
      const playersPayload = getPlayersList(
        state.playersOnField,
        Number(newTacticId)
      );
      await submitNewTeam({
        jugadores: playersPayload,
        idTactica: Number(newTacticId),
        idUsuario: userInitialData.idUsuarioDT,
      });
    } else {
      toast.show(TEXTS.defaultError);
    }
  };

  useUpdateEffect(() => {
    const { add: playersToAddCount, delete: playersToDeleteCount } =
      getInitialPlayersAddDeleteCount();

    const message = getInitialInstructionLabel(
      playersToDeleteCount,
      playersToAddCount
    );

    setInstruction(message);
  }, [fieldIsReady]);

  useUpdateEffect(() => {
    // Con el uso de este booleano
    // Puedo saber si la cancha esta dibujada, para asi calcular el mensaje inicial
    if (fieldIsReady && playersOnFieldCount > 0) {
      const nextStep = getNextStep();

      if (withAddAction) {
        if (nextStep) {
          setNextStep(nextStep);
        } else {
          handleSaveNewTeam();
        }
      } else {
        if (nextStep && nextStep.action === ChangeTacticAction.DELETE) {
          setNextStep(nextStep);
        } else {
          handleSaveNewTeam();
        }
      }
    }
  }, [fieldIsReady, state.playersOnField, playersOnFieldCount]);

  useUnmount(() => {
    handleUnmount();
  });

  const handleSelectPlayer = (player: PlayerClub | TemplatePlayer) => {
    if (isSelectedPlayerFromList(player)) {
      dispatch({
        type: TeamActionTypes.SET_STATE,
        payload: {
          selectedPlayerOnList: player,
          playerDetailsModalOpen: true,
        },
      });
    } else {
      const hasPlayer = Boolean(player.id);

      const payload = {
        selectedPlayerOnBuildTeam: player,
        ...(!hasPlayer && { selectedPosition: player.posicion?.nombreCorto }),
        ...(hasPlayer && {
          playerDetailsModalOpen: true,
        }),
      };

      dispatch({
        type: TeamActionTypes.SET_STATE,
        payload,
      });
    }
  };

  const handleResetHeaderInfo = () => {
    dispatch({
      type: TeamActionTypes.SET_STATE,
      payload: {
        showFiltersPlayersList: !state.showFiltersPlayersList,
      },
    });
  };

  // Set New Tactic with empty players
  const handleInit = (
    newTacticId: number,
    prevTacticId: number,
    teamDraft: PlayerClub[]
  ) => {
    const players = {
      defenders: [],
      midfielders: [],
      forwards: [],
      goalkeepers: null,
      substitutes: [],
    } as TacticOnField;

    if (newTacticId && prevTacticId) {
      const newTacticArray: number[] = TACTICS_ARR[newTacticId];
      const prevTacticArray: number[] = TACTICS_ARR[prevTacticId];

      // Construyo la tactica anterior
      const descriptor = new TacticDescriptor(prevTacticArray);

      const { 0: defCount, 1: midCount, 2: delCount } = newTacticArray;

      const prevDefendersArr = teamDraft.slice(
        descriptor.calcStartOfLine(EnumPosition.DEF),
        descriptor.calcEndOfLine(EnumPosition.DEF)
      );

      const prevMidArr = teamDraft.slice(
        descriptor.calcStartOfLine(EnumPosition.MID),
        descriptor.calcEndOfLine(EnumPosition.MID)
      );

      const prevDelArr = teamDraft.slice(
        descriptor.calcStartOfLine(EnumPosition.FWD),
        descriptor.calcEndOfLine(EnumPosition.FWD)
      );

      let orden = 15;

      // DEFENSORES
      prevDefendersArr.forEach((prevPlayer, index) => {
        const indexCount = index + 1;

        if (indexCount > defCount) {
          if (prevPlayer.id) {
            const item = {
              ...prevPlayer,
              orden,
            };

            players.defenders.push(
              <FieldPlayer
                data={item}
                id={String(item.orden)}
                positionLabel="DEF"
                onClick={() => {
                  handleSelectPlayer({
                    ...item,
                    posicion: { nombreCorto: 'DEF', id: 2 },
                  });
                }}
              />
            );
          }
        } else {
          const item = {
            ...prevPlayer,
            orden,
          };

          players.defenders.push(
            <FieldPlayer
              data={item}
              id={String(item.orden)}
              positionLabel="DEF"
              onClick={() => {
                handleSelectPlayer({
                  ...item,
                  posicion: { nombreCorto: 'DEF', id: 2 },
                });
              }}
            />
          );
        }

        orden++;
      });

      if (players.defenders.length < defCount) {
        const elementsToAddCount = countElementsBetween(
          players.defenders.length,
          defCount
        );

        for (let i = 0; i < elementsToAddCount; i++) {
          const item = {
            orden,
            titular: true,
            capitan: false,
          };

          players.defenders.push(
            <FieldPlayer
              data={item}
              id={String(item.orden)}
              positionLabel="DEF"
              onClick={() => {
                handleSelectPlayer({
                  ...item,
                  posicion: { nombreCorto: 'DEF', id: 2 },
                });
              }}
            />
          );
          orden++;
        }
      }

      // VOLANTES
      prevMidArr.forEach((prevPlayer, index) => {
        const indexCount = index + 1;

        if (indexCount > midCount) {
          if (prevPlayer.id) {
            const item = {
              ...prevPlayer,
              orden,
            };

            players.midfielders.push(
              <FieldPlayer
                data={item}
                id={String(item.orden)}
                positionLabel="VOL"
                onClick={() => {
                  handleSelectPlayer({
                    ...item,
                    posicion: { nombreCorto: 'VOL', id: 3 },
                  });
                }}
              />
            );
          }
        } else {
          const item = {
            ...prevPlayer,
            orden,
          };

          players.midfielders.push(
            <FieldPlayer
              data={item}
              id={String(item.orden)}
              positionLabel="VOL"
              onClick={() => {
                handleSelectPlayer({
                  ...item,
                  posicion: { nombreCorto: 'VOL', id: 3 },
                });
              }}
            />
          );
        }

        orden++;
      });

      if (players.midfielders.length < midCount) {
        const elementsToAddCount = countElementsBetween(
          players.midfielders.length,
          midCount
        );

        for (let i = 0; i < elementsToAddCount; i++) {
          const item = {
            orden,
            titular: true,
            capitan: false,
          };

          players.midfielders.push(
            <FieldPlayer
              data={item}
              id={String(item.orden)}
              positionLabel="VOL"
              onClick={() => {
                handleSelectPlayer({
                  ...item,
                  posicion: { nombreCorto: 'VOL', id: 3 },
                });
              }}
            />
          );
          orden++;
        }
      }

      // DELANTEROS
      prevDelArr.forEach((prevPlayer, index) => {
        const indexCount = index + 1;

        if (indexCount > delCount) {
          if (prevPlayer.id) {
            const item = {
              ...prevPlayer,
              orden,
            };

            players.forwards.push(
              <FieldPlayer
                data={item}
                id={String(item.orden)}
                positionLabel="DEL"
                onClick={() => {
                  handleSelectPlayer({
                    ...item,
                    posicion: { nombreCorto: 'DEL', id: 4 },
                  });
                }}
              />
            );
          }
        } else {
          const item = {
            ...prevPlayer,
            orden,
          };
          players.forwards.push(
            <FieldPlayer
              data={item}
              id={String(item.orden)}
              positionLabel="DEL"
              onClick={() => {
                handleSelectPlayer({
                  ...item,
                  posicion: { nombreCorto: 'DEL', id: 4 },
                });
              }}
            />
          );
        }

        orden++;
      });

      if (players.forwards.length < delCount) {
        const elementsToAddCount = countElementsBetween(
          players.forwards.length,
          delCount
        );

        for (let i = 0; i < elementsToAddCount; i++) {
          const item = {
            orden,
            titular: true,
            capitan: false,
          };

          players.forwards.push(
            <FieldPlayer
              data={item}
              id={String(item.orden)}
              positionLabel="DEL"
              onClick={() => {
                handleSelectPlayer({
                  ...item,
                  posicion: { nombreCorto: 'DEL', id: 4 },
                });
              }}
            />
          );
          orden++;
        }
      }

      players.goalkeepers = (
        <FieldPlayer
          data={teamDraft[0]}
          id="1"
          positionLabel="ARQ"
          onClick={() => {
            handleSelectPlayer({
              ...teamDraft[0],
              posicion: { nombreCorto: 'ARQ', id: 1 },
            });
          }}
        />
      );

      let substituteOrder = 11;

      const subtitutesArr = [
        teamDraft[11],
        teamDraft[12],
        teamDraft[13],
        teamDraft[14],
      ];

      subtitutesArr.forEach((player, index) => {
        const positionIndex = (index + 1) as KeysOf<
          typeof PLAYER_POSITION_BY_ID
        >;
        const positionName = PLAYER_POSITION_BY_ID[positionIndex];

        const substituteData = {
          ...player,
          orden: substituteOrder,
        };

        players.substitutes.push(
          <FieldPlayer
            key={substituteOrder}
            data={substituteData}
            id={`${substituteOrder}`}
            positionLabel={positionName}
            onClick={() => {
              handleSelectPlayer({
                ...player,
                orden: substituteOrder,
                posicion: { nombreCorto: positionName, id: positionIndex },
              });
            }}
          />
        );

        substituteOrder++;
      });

      const data = {
        type: TeamActionTypes.SET_STATE,
        payload: {
          teamDraft,
          tactic: { id: newTacticId, formation: TACTICS_ARR[newTacticId] },
          playersOnField: {
            goalkeepers: players.goalkeepers,
            defenders: players.defenders,
            midfielders: players.midfielders,
            forwards: players.forwards,
            substitutes: players.substitutes,
          },
        },
      };

      dispatch(data);
      setFieldIsReady(true);
    } else {
      toast.show(TEXTS.defaultError);
      handleGoBack();
    }
  };

  const instructionsMessage = newTacticId ? (
    <p className="text-left lg:text-center text-sm font-normal max-w-[365px] mx-auto">
      Para jugar con la{' '}
      <strong className="font-extrabold">
        Táctica {tacticToString(Number(newTacticId), '-')}
      </strong>
      {instruction}.
    </p>
  ) : null;

  const changeTacticOptions = useMemo(() => {
    if (step) {
      const positionsMap = {
        2: 'def',
        3: 'vol',
        4: 'del',
      } as const;

      const { add, delete: deleteObj } = getInitialPlayersAddDeleteCount();

      const key = positionsMap[step.position as KeysOf<typeof positionsMap>];
      const count =
        step.action === ChangeTacticAction.ADD
          ? add[key as KeysOf<typeof add>]
          : deleteObj[key as KeysOf<typeof deleteObj>];

      return {
        enablePosition: step.position,
        rowMessage: step.message,
        action: step.action,
        count,
      };
    }

    return undefined;
  }, [step]);

  const isSidebarDisabled = useMemo(() => {
    return !(step?.action === ChangeTacticAction.ADD);
  }, [step, state.selectedPlayerOnBuildTeam]);

  const selectedPositionLabel = useGetPlayerPositionByAbbreviation(
    state.selectedPosition,
    false
  );

  const showLoader = isLoading || !fieldIsReady || isLoadingOnSubmit;
  const timeout = !fieldIsReady || isLoadingOnSubmit;

  return (
    <Fragment>
      {<Loader isVisible={showLoader} timeout={timeout} />}
      <ChangeTacticLayout title="Cambio de Tactica">
        <FieldLayout.Main
          onConfirmMobile={
            <Button
              disabled
              className="w-[20.5rem] my-6"
              type="button"
              variant="primary"
            >
              Confirmar equipo
            </Button>
          }
        >
          {/* Close change tactic btn */}
          <button
            className="p-2 absolute right-2 top-1 z-[4] hidden lg:block"
            type="button"
            onClick={handleGoBack}
          >
            <FiX className="w-[50px] h-[50px] text-white" />
          </button>
          {toast.scopeToastContainer}
          {isMobile && (
            <div className="w-[20rem] mt-4">{instructionsMessage}</div>
          )}
          <FieldLayout.Inner>
            <FieldLayout.Field
              backDropOnClick={() => {
                dispatch({
                  type: TeamActionTypes.SET_STATE,
                  payload: {
                    selectedPlayerOnList: null,
                    selectedPlayerOnBuildTeam: null,
                    showFiltersPlayersList: false,
                    ...state.filtersApplied,
                  },
                });
              }}
              backDropOpen={Boolean(state.selectedPlayerOnBuildTeam)}
              changeTacticOptions={changeTacticOptions}
              context={EnumTeamContext.Build11}
              defenders={state.playersOnField?.defenders}
              floatingCard={
                <Fragment>
                  {!isLoading && newTacticId ? (
                    <TeamFormationWrapper
                      content={instructionsMessage}
                      teamName={userInitialData?.nombre_equipo ?? ''}
                      variant="change-tactic"
                    />
                  ) : null}
                </Fragment>
              }
              forwards={state.playersOnField?.forwards}
              goalkeeper={state.playersOnField?.goalkeepers}
              isMounted={isDesktop}
              midfielders={state.playersOnField?.midfielders}
              selectedPositionOrden={
                state.selectedPlayerOnBuildTeam &&
                'orden' in state.selectedPlayerOnBuildTeam &&
                state.selectedPlayerOnBuildTeam.orden
                  ? state.selectedPlayerOnBuildTeam.orden
                  : undefined
              }
              subtitutes={state.playersOnField?.substitutes}
              tacticId={state.tactic?.id ?? 1}
            />
          </FieldLayout.Inner>
        </FieldLayout.Main>
        {isDesktop && (
          <FieldLayout.Sidebar disabled={isSidebarDisabled}>
            <DesktopSidebar
              context={EnumTeamContext.Build11}
              handleSelectPlayerOnList={handleSelectPlayer}
              onClick={handleResetHeaderInfo}
            />
          </FieldLayout.Sidebar>
        )}
      </ChangeTacticLayout>

      {/* SlideOver para seleccion de jugadores */}
      {isMobile && (
        <SliderOver
          contentClassName="flex flex-col"
          open={Boolean(
            state.selectedPlayerOnBuildTeam &&
              !state.selectedPlayerOnBuildTeam?.id
          )}
        >
          <MobileSidebar
            backAction={() => {
              dispatch({
                type: TeamActionTypes.SET_STATE,
                payload: {
                  selectedPlayerOnList: null,
                  selectedPlayerOnBuildTeam: null,
                  selectedPosition: null,
                  filtersApplied: {
                    intoBudget: false,
                    orderBy: null,
                    orderClub: null,
                    valuesRange: [MIN_INPUT_RANGE, MAX_INPUT_RANGE],
                  },
                },
              });
            }}
            context={EnumTeamContext.Build11}
            handleSelectPlayerOnList={handleSelectPlayer}
            title={`Seleccionar ${selectedPositionLabel}`}
            onClick={handleResetHeaderInfo}
          />
        </SliderOver>
      )}

      {/* Modal para detalle del jugador */}
      <Modal
        bottomSheetClassName="px-[16px]"
        className="px-[1.06rem] lg:px-11 py-10"
        controlledOnClose={handleClosePlayerDetailsModal}
        isControlledOpen={Boolean(state.playerDetailsModalOpen)}
        render={() => {
          if (state.selectedPlayerOnList || state.selectedPlayerOnBuildTeam) {
            return (
              <DetailsPlayer
                playerId={
                  state.selectedPlayerOnBuildTeam?.id ??
                  state.selectedPlayerOnList?.id
                }
                playersOnField={state.playersOnField}
                selectedPlayerOnField={state.selectedPlayerOnBuildTeam}
                selectedPlayerOnList={state.selectedPlayerOnList}
                variant={
                  step
                    ? step.action === ChangeTacticAction.DELETE
                      ? 'change-tactic'
                      : 'add'
                    : undefined
                }
                onSubmitPlayer={handleClickPlayerAction}
              />
            );
          }

          return null;
        }}
        size="xs"
        variant="controlled"
      />

      {/* SlideOver para filtros */}
      {isMobile && (
        <SliderOver
          contentClassName="flex flex-col"
          open={Boolean(state.showFiltersPlayersList)}
        >
          <NavBar
            mobile={{
              rightContent: {
                customRightAction: () => {
                  dispatch({
                    type: TeamActionTypes.SET_STATE,
                    payload: {
                      showFiltersPlayersList: false,
                      ...state.filtersApplied,
                    },
                  });
                },
              },
              centerContent: {
                title: 'Filtros',
              },
            }}
          >
            <FormFilterPlayers context={EnumTeamContext.Changes11} />
          </NavBar>
        </SliderOver>
      )}
    </Fragment>
  );
};

/* ------------------------------------------------------ */
/* FUNCIONES TESTEABLES POR SEPARADO */
export type TacticOnFieldData = {
  goalkeepers: PlayerClub;
  defenders: PlayerClub[];
  midfielders: PlayerClub[];
  forwards: PlayerClub[];
  substitutes: PlayerClub[];
};

/**
 * lee GUI -> retorna datos de la gui
 * @param players
 * @returns
 */
ChangeTactic.getTacticOnFieldData = function (
  players: TacticOnField
): TacticOnFieldData {
  return {
    goalkeepers: players.goalkeepers?.props?.data,
    defenders: players.defenders.map((player) => player.props.data),
    midfielders: players.midfielders.map((player) => player.props.data),
    forwards: players.forwards.map((player) => player.props.data),
    substitutes: players.substitutes.map((player) => player.props.data),
  };
};

/**
 *
 * @param tacticOnFieldData datos de la GUI
 * @param targetTacticId táctica destino
 * @returns data para request POST
 */
ChangeTactic.getPlayersListFromData = function (
  tacticOnFieldData: TacticOnFieldData,
  targetTacticId: number
) {
  function fixLine(line: PlayerClub[], expectedSize: number) {
    let excess = line.length - expectedSize;
    const newLine: PlayerClub[] = [];
    // fix exceso
    line.forEach((player) => {
      if (excess > 0 && !player.id) {
        excess--; // skip
      } else {
        newLine.push(player);
      }
    });
    // fix faltante
    const shortage = expectedSize - newLine.length;
    for (let i = 1; i <= shortage; i++) {
      newLine.push({
        id: undefined,
        orden: -1, // orden corregido por función posterior
        titular: true,
        capitan: false,
      });
    }
    return newLine;
  }

  const tactic = TacticDescriptor.byId(targetTacticId);

  const playersArray: PlayerClub[] = [
    tacticOnFieldData.goalkeepers,
    ...fixLine(
      tacticOnFieldData.defenders,
      tactic.calcLineSize(EnumPosition.DEF)
    ),
    ...fixLine(
      tacticOnFieldData.midfielders,
      tactic.calcLineSize(EnumPosition.MID)
    ),
    ...fixLine(
      tacticOnFieldData.forwards,
      tactic.calcLineSize(EnumPosition.FWD)
    ),
    ...tacticOnFieldData.substitutes,
  ];

  return playersArray.map((player, index) => {
    return {
      ...(player?.id && {
        id: player.id,
      }),
      orden: index,
      titular: player?.titular ?? false,
      capitan: Boolean(player?.capitan),
    };
  });
};

/** exporto para test */
export function getPlayersList(
  players: TacticOnField,
  targetTacticId: number
): PlayerClub[] {
  const tacticOnFieldData = ChangeTactic.getTacticOnFieldData(players);

  const playersPayload = ChangeTactic.getPlayersListFromData(
    tacticOnFieldData,
    targetTacticId
  );

  if (playersPayload.length > 15) {
    console.error('bug en getPlayersList:', players, playersPayload);
    throw new Error('>15');
  }

  return playersPayload;
}

// funcion por eliminar
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getPlayersListIncorrecta(players: TacticOnField): PlayerClub[] {
  const playersArray: PlayerClub[] = [
    players.goalkeepers?.props?.data,
    ...players.defenders.map((player) => player.props.data),
    ...players.midfielders.map((player) => player.props.data),
    ...players.forwards.map((player) => player.props.data),
    ...players.substitutes.map((player) => player.props.data),
  ];

  return playersArray.map((player, index) => {
    return {
      ...(player?.id && {
        id: player.id,
      }),
      orden: index,
      titular: player?.titular ?? false,
      capitan: Boolean(player?.capitan),
    };
  });
}

/* ------------------------------------------------------ */
/* FIN DE FUNCIONES TESTEABLES POR SEPARADO */
